<template>
	<div id="nav">
		
	</div>
</template>

<script>
export default {
  name: 'nav_',
  data () {
    return {
     
    }
  }
}	
</script>

<style scoped>
	#nav{
		width:100%;
		height:50px;
		background-color:red;
	}
</style>


// WEBPACK FOOTER //
// src/components/subcomponents/nav.vue